import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { SelfServiceService } from '../../core/http/self-service.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ObsService } from '../../core/http/obs.service';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-online-finalize',
  templateUrl: './online-finalize.component.html',
  styleUrls: ['./online-finalize.component.scss'],
})
export class OnlineFinalizeComponent implements OnInit {
  isLoading = true;
  obsLoad = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  all: any = [];
  samples: any = [];
  Success;
  billId;
  id: string;
  message;
  record: any = [];
  templates: any = [];
  clinicalHistory: string;
  verifyLoad: boolean = false;
  verif: any = [];
  depts: any = [];
  subDepts: any = [];

  startdate;
  enddate;
  is_verified = JSON.parse(localStorage.getItem('verified'));
  dept_code = JSON.parse(localStorage.getItem('dept_code'));
  sub_dept_code = JSON.parse(localStorage.getItem('sub_dept_code'));
  investigation = '';
  name = '';
  gender = '';
  phone = '';
  is_finalized = JSON.parse(localStorage.getItem('finalize'));

  Template_Text = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '300px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    Id: new FormControl(''),
    OnlineBranchId: new FormControl(''),
    RefNo: new FormControl(''),
    OTP: new FormControl(''),
    PatientName: new FormControl(''),
    PatientAge: new FormControl(''),
    PatientGender: new FormControl(''),
    PatientOtherDetails: new FormControl(''),
    RegistrationCode: new FormControl(''),
    Email: new FormControl(''),
    Phone: new FormControl(''),
    StartDate: new FormControl(''),
    StopDate: new FormControl(''),
    IsVisibleToPatient: new FormControl(''),
    FinalizerEmail: new FormControl(''),
    FinalizerName: new FormControl(''),
    FinalizerComment: new FormControl(''),
    IsFinalized: new FormControl(true),
    DateFinalized: new FormControl(''),
    Title: new FormControl(''),
    ResultBody: new FormControl(''),
    LocalResultId: new FormControl(''),
    IsSynched: new FormControl(false),
  });

  constructor(
    private self: SelfServiceService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private obs: ObsService,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    let date = new Date();
    this.enddate = moment(date).format('YYYY-MM-DD');
    this.startdate = moment(date).format('YYYY-MM-DD');

    this.verif = [
      { name: 'Yes', value: 1 },
      { name: 'No', value: 0 },
      { name: 'All', value: -1 },
    ];

    this.id = this.activatedRoute.snapshot.paramMap.get('billId');

    this.getResult();

    this.setting.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.setting.getSubDept().subscribe(
      (resSuccess) => {
        this.subDepts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.sample.getResults(this.startdate, this.enddate).subscribe(
      (resSuccess: any) => {
        this.all = resSuccess.data.filter((t) => t.service_name == 'Obstetric');
        this.obsLoad = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  getResult() {
    this.isLoading = true;
    this.self
      .getResultFinalizer(
        this.startdate,
        this.enddate,
        this.dept_code,
        this.sub_dept_code,
        this.investigation,
        this.name,
        this.gender,
        this.phone,
        this.is_finalized
      )
      .subscribe(
        (resSuccess: any) => {
          this.data = resSuccess;
          this.isLoading = false;
          console.log(this.data);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
  }

  // getTemplate(result_id) {
  //   this.sample
  //   .getdetails(result_id)
  //   .subscribe(
  //     (resSuccess) => {
  //       this.templates = resSuccess
  //       this.Template_Text = this.templates.data
  //       this.stateForm.patchValue({
  //         formatstr: this.templates.data
  //       });
  //       console.log(this.templates.data)
  //     },
  //     (resErr) => {
  //       this.Errors = resErr;
  //     }
  //   )
  // }

  finalized(event) {
    localStorage.setItem('finalize', event.value);
    console.log(this.is_finalized);
  }

  dept(event) {
    localStorage.setItem('dept_code', event.value);
    console.log(this.dept_code);
  }
  sub(event) {
    localStorage.setItem('sub_dept_code', event.value);
    console.log(this.sub_dept_code);
  }

  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.enddate);
  }

  addRecord(item) {
    // this.stateForm.reset()
    if (item.service_name === 'Obstetric') {
      this.obs.addItem(item);
      this.router.navigateByUrl('/obs-finalize', { state: { patient: item } });
    } else {
      this.record = item;
      this.clinicalHistory = item.clinical_history;
      this.mode = 'wiz';
      this.Errors = '';
      // this.getTemplate(item.result_id);
      this.stateForm.patchValue({
        Id: item.Id,
        OnlineBranchId: item.OnlineBranchId,
        RefNo: item.RefNo,
        OTP: item.OTP,
        PatientName: item.PatientName,
        PatientAge: item.PatientAge,
        PatientGender: item.PatientGender,
        PatientOtherDetails: item.PatientOtherDetails,
        RegistrationCode: item.RegistrationCode,
        Email: item.Email,
        Phone: item.Phone,
        StartDate: item.StartDate,
        StopDate: item.StopDate,
        IsVisibleToPatient: item.IsVisibleToPatient,
        FinalizerEmail: item.FinalizerEmail,
        FinalizerName: item.FinalizerName,
        FinalizerComment: item.FinalizerComment,
        DateFinalized: item.DateFinalized,
        Title: item.Title,
        ResultBody: item.ResultBody,
        LocalResultId: item.LocalResultId,
      });
      console.log(this.stateForm.value);
      console.log(this.record);
    }
  }
  back() {
    this.mode = 'form';
  }
  backs() {
    this.router.navigateByUrl('/finalise-encounter');
  }

  done() {
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      Id,
      OnlineBranchId,
      RefNo,
      OTP,
      PatientName,
      PatientAge,
      PatientGender,
      PatientOtherDetails,
      RegistrationCode,
      Email,
      Phone,
      StartDate,
      StopDate,
      IsVisibleToPatient,
      FinalizerEmail,
      FinalizerName,
      FinalizerComment,
      IsFinalized,
      DateFinalized,
      Title,
      ResultBody,
      LocalResultId,
      IsSynched,
    } = this.stateForm.value;
    this.self
      .saveResult(
        Id,
        OnlineBranchId,
        RefNo,
        OTP,
        PatientName,
        PatientAge,
        PatientGender,
        PatientOtherDetails,
        RegistrationCode,
        Email,
        Phone,
        StartDate,
        StopDate,
        IsVisibleToPatient,
        FinalizerEmail,
        FinalizerName,
        FinalizerComment,
        IsFinalized,
        DateFinalized,
        Title,
        ResultBody,
        LocalResultId,
        IsSynched
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this.getResult();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.mode = 'form';
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
    // this.stateForm.patchValue({
    //   formatstr: this.Template_Text
    // });
    console.log(this.stateForm.value);
    // this._snackBar.open('Template Added Successfully', '', {
    //   duration: 2000,
    //   verticalPosition: 'top',
    // });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text.replace(/"/g, "'");
  }

  pushOnline() {
    let id = JSON.stringify([this.record.LocalResultId]);
    this.sample
      .pushOnline(this.record.LocalResultId, '', '', id, '', '', '', '')
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  updateIsVerifeid() {
    this.verifyLoad = true;
    const is_verify_action = true;
    const is_collect_action = true;
    const is_acknowledge_action = true;
    const { sample_id, bill_id } = this.stateForm.value;
    this.sample
      .updateIsVerified(
        sample_id,
        bill_id,
        is_verify_action,
        is_acknowledge_action,
        is_collect_action
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.verifyLoad = false;
          console.log(resSuccess);

          if (this.message.success) {
            this.getResult();
            this.stateForm.reset();
            this._snackBar.open('Verified Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    let is_finalized = true;
    const { formatstr, result_id } = this.stateForm.value;
    // this.sample
    //   .postResultDetail(
    //     result_id,
    //     formatstr,
    //   )
    //   .subscribe(
    //     (resSuccess) => {

    //       this.message = resSuccess
    //       this.isSaveLoading = false;
    //       this.stateForm.reset()

    //       if (this.message.success) {
    //         this.getResult()
    //         this._snackBar.open('Saved Successfully', '', {
    //           duration: 2000,
    //           verticalPosition: 'top',
    //         });
    //       }
    //       else {
    //         this.Errors = "Not successful, please try again"
    //         console.log("Error Please Try Agian")
    //         this._snackBar.open('Error Please Try Agian', '', {
    //           duration: 2000,
    //           verticalPosition: 'top',
    //         });
    //       }

    //     },
    //     (resErr) => {
    //       this.isSaveLoading = false;
    //       this.Errors = resErr;
    //       console.log(resErr)
    //     }
    //   );
    this.sample.postResultFinalize(result_id, is_finalized).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          console.log(this);
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.stateForm.reset();
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Result already Finalized', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('Error: try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
